import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";
import { isFunction } from "@gameApp/utils/isFunction";
import { isObject } from "@gameApp/utils/object";
import isEmpty from "lodash/isEmpty";

export function applyContextOptions(
  options: Omit<BasicDrawOptions, "translateX | translateY">,
): void {
  const { context, contextOptions } = options;

  if (isObject(contextOptions) && !isEmpty(contextOptions)) {
    context.save();

    for (const [key, value] of Object.entries(contextOptions)) {
      if (isFunction(value)) {
        value(context);
      } else {
        Object.assign(context, { [key]: value });
      }
    }
  }
}

export function restoreContextOptions(options: BasicDrawOptions): void {
  const { context, contextOptions } = options;

  if (isObject(contextOptions) && Object.entries(contextOptions).length > 0) {
    context.restore();
  }
}

export function forceRestoreContextOptions(
  context: CanvasRenderingContext2D,
): void {
  if (context instanceof CanvasRenderingContext2D) {
    context.restore();
  }
}
